import React, { useState } from "react";
import { FollowUpCard } from "./cards/FollowUpCard";
import { OutsideReferralCard } from "./cards/OutsideReferralCard";
import { ReferProgramCard } from "./cards/ReferProgramCard";
import { InternalNotesCard } from "./cards/InternalNotesCard";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { PrescriptionPreviewDialog } from "../../dialogs/PrescriptionPreviewDialog";
import { PrescriptionViewDialog } from "../../dialogs/PrescriptionViewDialog";

interface FollowupReferralTabProps {
  appointmentId: string;
  isCompleted?: boolean;
  prescriptionUrl?: string | null;
}

export const FollowupReferralTab = ({
  appointmentId,
  isCompleted = false,
  prescriptionUrl,
}: FollowupReferralTabProps) => {
  const [showPreview, setShowPreview] = useState(false);
  const [showView, setShowView] = useState(false);

  return (
    <div className="space-y-4">
      <FollowUpCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="prescription"
      />
      <OutsideReferralCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="prescription"
      />
      <ReferProgramCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="prescription"
      />
      <InternalNotesCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="prescription"
      />

      {/* Preview button for active appointments, View button for completed appointments */}
      <div className="flex justify-end pt-2">
        {isCompleted ? (
          <Button onClick={() => setShowView(true)} className="gap-2">
            <Eye className="size-4" />
            View Prescription
          </Button>
        ) : (
          <Button onClick={() => setShowPreview(true)} className="gap-2">
            <Eye className="size-4" />
            Preview Prescription
          </Button>
        )}
      </div>

      {/* Preview Dialog for active appointments */}
      <PrescriptionPreviewDialog
        open={showPreview}
        onOpenChange={setShowPreview}
        appointmentId={appointmentId}
      />

      {/* View Dialog for completed appointments */}
      <PrescriptionViewDialog
        open={showView}
        onOpenChange={setShowView}
        appointmentId={appointmentId}
        prescriptionUrl={prescriptionUrl}
        title="Prescription"
      />
    </div>
  );
};
